import { css } from '@emotion/css';
import { cssVarV2 } from '@streamlain/theme/v2';

export const cellDivider = css({
  flex: '0 0 1px',
  height: '100%',
  minWidth: '1px',
  width: '1px',
  backgroundColor: cssVarV2.database.border,
});
